import type { SVGComponentProps } from 'BreetHelpers';

export const FilterIcon = ({ ...props }: SVGComponentProps) => (
	<svg
		width='15'
		height='16'
		viewBox='0 0 15 16'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		{...props}
	>
		<path
			opacity='0.4'
			d='M12.6952 3.11051V4.4395C12.6952 4.92277 12.3931 5.52686 12.0911 5.8289L9.49354 8.12442C9.13109 8.42647 8.88945 9.03055 8.88945 9.51382V12.1114C8.88945 12.4738 8.64782 12.9571 8.34578 13.1383L7.50006 13.682C6.71475 14.1653 5.62739 13.6216 5.62739 12.6551V9.45341C5.62739 9.03055 5.38576 8.48687 5.14412 8.18483L4.54004 7.55054L8.05582 1.90234H11.487C12.1515 1.90234 12.6952 2.44602 12.6952 3.11051Z'
			fill='#022745'
		/>
		<path
			d='M7.07745 1.90234L3.94829 6.92229L2.84885 5.76849C2.54681 5.46645 2.30518 4.92277 2.30518 4.56032V3.17092C2.30518 2.44602 2.84885 1.90234 3.51335 1.90234H7.07745Z'
			fill='#022745'
		/>
	</svg>
);
